exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".home[data-v-0fadb541]{display:flex;flex-direction:column;justify-content:center}.MoreButton[data-v-0fadb541]{min-width:10%;font-weight:600;border-radius:10em;border:1px solid #18c683;padding:.4em;color:#fff;align-self:center;background:#18c683 none repeat scroll 0 0!important;transition:transform .2s ease 0s;box-shadow:0 0 10px 0 rgba(24,198,131,.5);margin:1em 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0fadb541","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/home.vue
// module id = 315
// module chunks = 0